export default {
  decision: null,
}
